import React from 'react';
import PropTypes from 'prop-types';

import NotificationsScreen from '~/components/Notifications/NotificationsScreen';

const ClaimNotificationsCard = ({
  userContext,
  showExposure,
  actionComponent,
  onlyDismissed,
  dismissedNavigationComponent,
  useDefaultAssigneeFromPreferences,
}) => {
  return (
    <NotificationsScreen
      displayOptions={{ showExposure, showClaim: !userContext }}
      actionComponent={actionComponent}
      useDefaultAssigneeFromPreferences={useDefaultAssigneeFromPreferences}
      onlyDismissed={onlyDismissed}
      dismissedNavigationComponent={dismissedNavigationComponent}
    />
  );
};

ClaimNotificationsCard.propTypes = {
  userContext: PropTypes.bool,
  showExposure: PropTypes.bool,
  actionComponent: PropTypes.node,
  onlyDismissed: PropTypes.bool,
  dismissedNavigationComponent: PropTypes.node,
  useDefaultAssigneeFromPreferences: PropTypes.bool,
};

export default ClaimNotificationsCard;
